import React from "react";

const BASE_CLASSES = [
  "inline-flex",
  "items-center",
  "justify-center",
  "gap-2.5",
  "rounded-full",
  "border",
  "px-6",
  "py-3.5",
  "text-sm",
  "font-black",
  "transition",
  "duration-300",
  "hover:-translate-y-0.5",
  "focus:outline-none",
  "focus-visible:ring-2",
  "focus-visible:ring-orange-400",
  "focus-visible:ring-offset-2",
  "disabled:pointer-events-none",
  "disabled:cursor-not-allowed",
  "disabled:opacity-50",
].join(" ");

const VARIANTS = {
  primary: [
    "!border-orange-500",
    "!bg-orange-500",
    "!text-white",
    "shadow-xl",
    "shadow-orange-950/20",
    "hover:!border-orange-400",
    "hover:!bg-orange-400",
    "dark:!border-orange-500",
    "dark:!bg-orange-500",
    "dark:!text-white",
    "dark:hover:!bg-orange-400",
  ].join(" "),

  secondary: [
    "!border-white/20",
    "!bg-white/10",
    "!text-white",
    "backdrop-blur",
    "hover:!border-white/30",
    "hover:!bg-white/15",
    "dark:!border-white/20",
    "dark:!bg-white/10",
    "dark:!text-white",
  ].join(" "),

  dark: [
    "!border-[#004b86]",
    "!bg-[#004b86]",
    "!text-white",
    "shadow-xl",
    "shadow-blue-950/20",
    "hover:!border-[#003c6c]",
    "hover:!bg-[#003c6c]",
    "dark:!border-blue-600",
    "dark:!bg-blue-600",
    "dark:!text-white",
    "dark:hover:!bg-blue-500",
  ].join(" "),

  light: [
    "!border-slate-200",
    "!bg-white",
    "!text-slate-900",
    "shadow-lg",
    "hover:!border-orange-300",
    "hover:!text-orange-600",
    "dark:!border-slate-700",
    "dark:!bg-slate-900",
    "dark:!text-white",
    "dark:hover:!border-orange-400",
    "dark:hover:!text-orange-300",
  ].join(" "),

  white: [
    "!border-white",
    "!bg-white",
    "!text-[#004b86]",
    "shadow-xl",
    "shadow-blue-950/20",
    "hover:!border-orange-50",
    "hover:!bg-orange-50",
    "hover:!text-orange-600",
    "dark:!border-white",
    "dark:!bg-white",
    "dark:!text-[#004b86]",
    "dark:hover:!bg-orange-50",
    "dark:hover:!text-orange-600",
  ].join(" "),
};

export default function ScoreButton({
  children,
  icon: Icon,
  onClick,
  variant = "primary",
  className = "",
  type = "button",
  disabled = false,
  ...buttonProps
}) {
  const variantClasses =
    VARIANTS[variant] || VARIANTS.primary;

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={[
        BASE_CLASSES,
        variantClasses,
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      {...buttonProps}
    >
      <span>{children}</span>

      {Icon ? (
        <Icon
          aria-hidden="true"
          className="shrink-0 text-sm"
        />
      ) : null}
    </button>
  );
}